import React, { FC, ReactNode } from 'react';

import * as Styled from './styled';

type Props = {
  children: ReactNode | ReactNode[];
  isActive: boolean;
  url: string;
};

/**
 * A single quick filter link component
 *
 * @param props          Props passed to the component
 * @param props.children The quick filter text
 * @param props.isActive Children passed to the component
 * @param props.url      Url to redirect to
 * @returns              Styled router link component
 */
const QuickFilterLink: FC<Props> = ({ children, isActive, url }) => {
  return (
    <Styled.Link
      aria-current={isActive ? 'location' : undefined}
      data-active={isActive}
      to={url}
    >
      {children}
    </Styled.Link>
  );
};

export default QuickFilterLink;
